/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setUserData } from "../../redux/actions/user";
import { getNavigationByUser } from "../../redux/actions/navigation";
import jwtHelper from "../jwtHelper";
import history from "../history";

const Auth = ({ children, setUserData, getNavigationByUser }) => {
  
  const checkJwtAuth = async () => {
    let loginStatus = await jwtHelper.isLoggedIn();
    if (loginStatus) {
      setUserData(JSON.parse(localStorage.getItem("auth_user")));
    } else {
      history.push({
        pathname: "/session/signin"
      });
    }
  };

  setUserData(JSON.parse(localStorage.getItem("auth_user")));
  
  useEffect(() => {
    checkJwtAuth();
    getNavigationByUser();
  }, [setUserData, getNavigationByUser]);

  return <Fragment>{children}</Fragment>;
};

const mapStateToProps = state => ({
  setUserData: PropTypes.func.isRequired,
  getNavigationByUser: PropTypes.func.isRequired,
  login: state.login
});

export default connect(mapStateToProps, { setUserData, getNavigationByUser })(
  Auth
);
